import { inject, Injectable, INJECTOR } from '@angular/core';
import { handleRequestError } from '@softline/application';
import { CertificateRepository } from './certificate.repository';
import {
  Certificate,
  CERTIFICATE_DOCUMENT_TYPE_LABELS,
  CertificateDocumentType,
  DocumentCertificate,
  DocumentCertificateRequest,
} from './certificate.types';

@Injectable({ providedIn: 'root' })
export class CertificateService {
  readonly #repository = inject(CertificateRepository);
  readonly #injector = inject(INJECTOR);

  async getSupplierCertificates(supplierId: number): Promise<Certificate[]> {
    try {
      return await this.#repository.loadSupplierCertificates(supplierId);
    } catch (e) {
      handleRequestError(e, this.#injector, { show: true });
      throw e;
    }
  }

  async getDocumentCertificate(
    documentType: CertificateDocumentType,
    documentId: number
  ): Promise<DocumentCertificate | null> {
    try {
      return await this.#repository.loadDocumentCertificate(documentType, documentId);
    } catch (e) {
      handleRequestError(e, this.#injector);
      throw e;
    }
  }

  getDocumentTypeLabel(documentType: CertificateDocumentType): string {
    return CERTIFICATE_DOCUMENT_TYPE_LABELS[documentType];
  }

  async setDocumentCertificate(request: DocumentCertificateRequest): Promise<void> {
    try {
      await this.#repository.saveDocumentCertificate(request);
    } catch (e) {
      handleRequestError(e, this.#injector, { show: true });
      throw e;
    }
  }
}
